import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import _ from "lodash";
import { getLocalStorage } from "@/helpers/common";
import { USER_INFO_KEY } from "@/constants/common";
import { SESSION_RESET } from "@/reducers";

export const currentUserId = () => _.get(getLocalStorage(USER_INFO_KEY), "userInfo.userId", null) ?? null;

const useSessionReset = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryClient = useQueryClient();
  const owner = useRef(currentUserId());

  useEffect(() => {
    const check = () => {
      const now = currentUserId();
      if (String(now) !== String(owner.current)) {
        const wasGuest = owner.current === null;
        owner.current = now;
        // A guest holds no private data, and signing in through the modal does not reload,
        // so clearing here would wipe the details the sign-in just fetched.
        if (wasGuest) return;
        dispatch({ type: SESSION_RESET });
        // Query keys such as ["userDetails"] are not user-scoped, so drop the
        // cache with the store or the previous user's data renders for the next.
        queryClient.clear();
      }
    };
    check();
    window.addEventListener("storage", check);
    window.addEventListener("focus", check);
    return () => {
      window.removeEventListener("storage", check);
      window.removeEventListener("focus", check);
    };
  }, [dispatch, queryClient, location.pathname, location.search]);
};

export default useSessionReset;
